import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { CheckMark, FormElementContainer } from "components";
import "./Options.scss";

// @Note temporarily disable forsa and islamic fund of MUT until unit + amount is displayed
// const FORSA_ID = 'NWM00033';
// const ISLAMIC_ID = 'NWM00017';

const Options = (props) => (
  <div
    className={`options ${props.isChildOptionList ? "child-optionList" : ""}`}
  >
    <FormElementContainer isMultpleElements={props.isMultpleElements}>
      {props.optionList &&
        props.optionList.map((item, i) => (
          <CheckMark
            key={`${item.name}-${i}`}
            id={item.id}
            child={item.child}
            type={props.type}
            label={
              props.isTranslate
                ? props.intl.formatMessage({ id: item.label })
                : item.label
            }
            name={props.name}
            hasContainer={props.hasContainer}
            defaultValue={props.defaultValue}
            onCheckMarkChange={props.onCheckMarkChange}
            useLabel={props.useLabel}
            // isDisabled={props.isDisabledForAll} // || item.id === 'NW-MAR-IVS-DIV' || item.id === 'NW-MAR-CLA-MFT' || item.id === 'NW-MAR-IEY-MUT' temporary disabled Dividend Yield || Mutual Fund
            isDisabled={
              item.id === "NW-MAR-TOI-MAR" ||
              item.id === "NW-MAR-CLA-AA-MAR" ||
              props.isDisabled
            } // temporarily disable iMarkaz portfolio
            withInfo={props.withInfo}
            onWithInfoClick={props.onWithInfoClick}
          />
        ))}
    </FormElementContainer>
    {!props.isValid && props.isSubmitClicked && props.errorMessage && (
      <span className="notification notification--error">
        {props.errorMessage[0]}
      </span>
    )}
  </div>
);

Options.propTypes = {
  /** Option list (array of objects) */
  optionList: PropTypes.arrayOf(PropTypes.object),
  /** isMultpleElements options */
  isMultpleElements: PropTypes.bool,
  /** is valid options */
  isValid: PropTypes.bool,
  /** error message */
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  /** is touched or submitted */
  isSubmitClicked: PropTypes.bool,
  /** is disable all option */
  isDisabledForAll: PropTypes.bool,
  /** translate labels or not */
  isTranslate: PropTypes.bool,
};

Options.defaultProps = {
  optionList: [],
  isMultpleElements: false,
  isValid: true,
  errorMessage: null,
  isSubmitClicked: false,
  isDisabledForAll: false,
  isTranslate: true,
};

export default injectIntl(Options);
